import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import EditableFormattedMessage from './EditableFormattedMessage';
import { TestReviewModeContext } from '../contexts/TestReviewModeContext';

const resolveMessageKey = (descriptor) => {
  if (!descriptor) return null;
  if (typeof descriptor === 'string') return descriptor;
  if (typeof descriptor.id === 'string') return descriptor.id;
  return null;
};

export default function ReviewFormattedMessage({ descriptor, ...formattedProps }) {
  const reviewMode = useContext(TestReviewModeContext);
  const isEditingEnabled = Boolean(
    reviewMode?.enabled && (reviewMode?.editMode || reviewMode?.translationMode)
  );

  const msgKey = resolveMessageKey(descriptor);

  if (isEditingEnabled && msgKey) {
    return <EditableFormattedMessage msgKey={msgKey} />;
  }

  if (!descriptor) {
    return null;
  }

  return <FormattedMessage {...descriptor} {...formattedProps} />;
}
